import { MenuItems } from '@menu-lib/components/AppLayout/MainMenu/menuItems';
import { MenuItemRegistry } from '@menu-lib/components/AppLayout/MainMenu/menuRegistry';
import { type EnvironmentSettings, type LinkItem } from '@menu-lib/components/AppLayout/types';

MenuItemRegistry.register(MenuItems.MuterenRoyeren, {
  isVisible: (settings: EnvironmentSettings) =>
    settings.heeftRoyerenPermissie || settings.heeftMutatieStartenPermissie,
  create: (settings: EnvironmentSettings): LinkItem => {
    const title =
      settings.heeftMutatieStartenPermissie && settings.heeftRoyerenPermissie
        ? 'Muteren / Royeren'
        : settings.heeftMutatieStartenPermissie && !settings.heeftRoyerenPermissie
          ? 'Muteren'
          : 'Royeren';

    return {
      itemtype: 'link',
      menuItem: MenuItems.MuterenRoyeren,
      title,
      url: '/app/crm/relatiegegevens?muteren=true',
      iconclass: 'fas fa-file-signature',
      target: '_top',
    };
  },
});
